import { useState } from 'react';

import type { LeadListRowHighlight, LeadListRowHighlightKey } from './rowHighlight';

type RowHighlightControlledProps = {
    isRowHighlighted: LeadListRowHighlight;
    setIsRowHighlighted: (highlight: LeadListRowHighlight) => void;
};

type UncontrolledProps = {
    isRowHighlighted?: never;
    setIsRowHighlighted?: never;
};

export type RowHighlightProps = RowHighlightControlledProps | UncontrolledProps;

export const useRowHighlightDialog = (
    highlightKey: LeadListRowHighlightKey,
    { isRowHighlighted, setIsRowHighlighted }: RowHighlightProps = {},
) => {
    const [uncontrolledDialogOpen, setUncontrolledDialogOpen] = useState(false);
    const isControlled = setIsRowHighlighted != null;
    const dialogOpen = isControlled ? isRowHighlighted === highlightKey : uncontrolledDialogOpen;

    const setDialogOpen = (open: boolean) => {
        if (isControlled) {
            setIsRowHighlighted(open ? highlightKey : false);
            return;
        }
        setUncontrolledDialogOpen(open);
    };

    return { dialogOpen, setDialogOpen };
};
